// Side-effect import: registers the `beforeinstallprompt` listener at module
// load. Chrome can fire that event during initial HTML parse, before any
// useEffect runs, so the InstallPrompt's hook alone would miss it.
import '@ordo/ui/pwa-install-capture'
// Agent embed ships its own compiled stylesheet so its visual language
// is identical across every host without per-app Tailwind config. Plan 24.
import '@ordo/agent-embed/styles.css'

import { initFaro } from '@ordo/faro'
import { FaroErrorBoundary } from '@ordo/faro/error-boundary'
import { mountScreenshotBridge } from '@ordo/screenshot-bridge'
import { InstallPrompt } from '@ordo/ui/install-prompt'
import { Toaster } from '@ordo/ui/sonner'
import { QueryClientProvider } from '@tanstack/react-query'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router'

import { queryClient } from './lib/query-client'
import { router } from './routes'
import { useAuthStore } from './stores/auth'

// Workspaces annotator handshake — no-op unless framed by previews.ordo.com.
mountScreenshotBridge()

// Start the session revalidation NOW, in parallel with router mount, instead
// of waiting for ProtectedRoute's post-paint effect. The store's in-flight
// dedupe makes the later effect call a no-op.
void useAuthStore.getState().fetchUser()

initFaro({
  appName: 'boombox',
  collectorUrl: '/api/telemetry',
  environment: import.meta.env.MODE,
})

const rootElement = document.getElementById('root')
if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    <FaroErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <NuqsAdapter>
          <RouterProvider router={router} />
          <InstallPrompt appName="Ordo Communications" dismissedKey="boombox-install-prompt-dismissed" />
          <Toaster />
        </NuqsAdapter>
      </QueryClientProvider>
    </FaroErrorBoundary>,
  )
}
